module.exports = __webpack_public_path__ + "static/media/unicorn_platform_plus_appsumo.9dd5df66.svg";